import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const loginIssueRoute: RouteConfig<'with-page'> = {
    name: 'Error - Login Issue',
    path: '/error/loginissue',
    page: lazy(() => import('.')),
}